<div class="favorite-wrapper gtm-favorite" [attr.data-gtmlabel]="gtmLabel">
    <app-link-button
        [classList]="classList"
        class="favorite selenium-favorite"
        [hideLabelOnTablet]="hideLabelOnTablet"
        [hideLabelOnSmallDevices]="hideLabelOnSmallDevices"
        [hideLabelOnMobile]="hideLabelOnMobile"
        [ngClass]="{ large: isLarge }"
        [tooltip]="!userService.isLoggedIn() || disable ? loggedoutTooltip : loggedinTooltip"
        label="Favorite"
        [icon]="favoriteId ? 'FavoriteFilled' : 'Favorite'"
        (trigger)="onFavoriteClick()"
        [disable]="disable"
    >
    </app-link-button>
</div>
